__turbopack_context__.v({
  "error": "submitReview-module-scss-module__WmhJfW__error",
  "formError": "submitReview-module-scss-module__WmhJfW__formError",
  "formRow": "submitReview-module-scss-module__WmhJfW__formRow",
  "ratingsWrapper": "submitReview-module-scss-module__WmhJfW__ratingsWrapper",
  "reviewModalWrapper": "submitReview-module-scss-module__WmhJfW__reviewModalWrapper",
  "submitButton": "submitReview-module-scss-module__WmhJfW__submitButton",
  "wrapper": "submitReview-module-scss-module__WmhJfW__wrapper",
});
